import { useEffect, useRef } from 'react';
export default function usePrevious(state) {
    var ref = useRef();
    useEffect(function () {
        ref.current = state;
    });
    return ref.current;
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/react-use/esm/usePrevious.js
// module id = null
// module chunks = 